import { render, staticRenderFns } from "./Receipt-products-search.vue?vue&type=template&id=1b85c8fb"
import script from "./Receipt-products-search.vue?vue&type=script&lang=js"
export * from "./Receipt-products-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports